import { render, staticRenderFns } from "./complaints.vue?vue&type=template&id=56dc8aec&scoped=true"
import script from "./complaints.vue?vue&type=script&lang=js"
export * from "./complaints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dc8aec",
  null
  
)

export default component.exports